module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_vm._v("Site:")]), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Site"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.sitecode),
      callback: function($$v) {
        _vm.sitecode = $$v
      },
      expression: "sitecode"
    }
  }, _vm._l((_vm.codes.sites), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code + ' - ' + item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), (this.searchField != 'Dossier' || this.searchFilter == '') ? _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Vanaf periode"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.periode),
      callback: function($$v) {
        _vm.periode = $$v
      },
      expression: "periode"
    }
  }, _vm._l((_vm.codes.periods), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.value,
        "value": item.code
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_vm._v("\n          Filter: \n\t\t\t\t  "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select field"
    },
    model: {
      value: (_vm.searchField),
      callback: function($$v) {
        _vm.searchField = $$v
      },
      expression: "searchField"
    }
  }, _vm._l((_vm.searchFields), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "Search For"
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v("Filter")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleImport
    }
  }, [_vm._v("Import")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "D",
      "label": "Dossier",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "P",
      "label": "Period",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "B",
      "label": "Booker",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "X",
      "label": "Destination",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "S",
      "label": "Departure",
      "width": "110",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right",
      "prop": "A",
      "label": "Amount",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(_vm.util.formatMoney(scope.row.A)) + " ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "b",
      "label": "BS",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "l",
      "label": "LS",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "140",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "el-icon-chat-line-square"
          },
          on: {
            "click": function($event) {
              return _vm.handleView(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small",
            "icon": "el-icon-aim"
          },
          on: {
            "click": function($event) {
              return _vm.handleXml(scope.row, 0)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev,pager,next,jumper,sizes",
      "total": _vm.mainTotal,
      "page-sizes": [10, 15, 25, 50, 100],
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "140px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    staticStyle: {
      "height": "440px"
    },
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.clickTab
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "T1"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Dossier")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dossier/Status : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['D']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'D', $$v)
      },
      expression: "editForm['D']"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100px",
      "float": "right"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['l']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'l', $$v)
      },
      expression: "editForm['l']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Booker : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['B']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'B', $$v)
      },
      expression: "editForm['B']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Main Dest : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['D']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'D', $$v)
      },
      expression: "editForm['D']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Bookdate : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['a']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'a', $$v)
      },
      expression: "editForm['a']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Departuredate : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['S']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'S', $$v)
      },
      expression: "editForm['S']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Returndate : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm['e']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'e', $$v)
      },
      expression: "editForm['e']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dossier Geladen : "
    }
  }, [_c('el-date-picker', {
    staticClass: "startTimeBox",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "type": "datetime",
      "clearable": true,
      "placeholder": "Select Date and Time",
      "format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.editForm['c']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'c', $$v)
      },
      expression: "editForm['c']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Booked By : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['m']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'm', $$v)
      },
      expression: "editForm['m']"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "LOCATE"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Segments")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Accommodation : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "8",
      "readonly": "readonly",
      "type": "textarea"
    },
    model: {
      value: (_vm.detailLocate),
      callback: function($$v) {
        _vm.detailLocate = $$v
      },
      expression: "detailLocate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Transport : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "9",
      "readonly": "readonly",
      "type": "textarea"
    },
    model: {
      value: (_vm.detailTransport),
      callback: function($$v) {
        _vm.detailTransport = $$v
      },
      expression: "detailTransport"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "FIN"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" Finance")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Details : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "18",
      "readonly": "readonly",
      "type": "textarea"
    },
    model: {
      value: (_vm.detailFin),
      callback: function($$v) {
        _vm.detailFin = $$v
      },
      expression: "detailFin"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-close",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "90%",
      "title": "View Original XML",
      "visible": _vm.viewXmlVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.viewXmlVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Dossier:",
      "prop": "dossier"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.dossier),
      callback: function($$v) {
        _vm.dossier = $$v
      },
      expression: "dossier"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Location:",
      "prop": "id"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.xmlfile),
      callback: function($$v) {
        _vm.xmlfile = $$v
      },
      expression: "xmlfile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "label": "XML : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "25"
    },
    model: {
      value: (_vm.xmldata),
      callback: function($$v) {
        _vm.xmldata = $$v
      },
      expression: "xmldata"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewXmlVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "90%",
      "title": "View Base Dossier Details",
      "visible": _vm.viewDetailsVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.viewDetailsVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "min-height": "450px"
    },
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Dossier :",
      "prop": "dossier"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.dossier),
      callback: function($$v) {
        _vm.dossier = $$v
      },
      expression: "dossier"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100px",
      "float": "Right"
    },
    attrs: {
      "size": "small",
      "Placeholder": "Select Type"
    },
    on: {
      "change": _vm.reloadData
    },
    model: {
      value: (_vm.outtype),
      callback: function($$v) {
        _vm.outtype = $$v
      },
      expression: "outtype"
    }
  }, _vm._l((_vm.outtypes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "label": "JSON : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-family": "system",
      "font-size": "12px"
    },
    attrs: {
      "readonly": "",
      "type": "textarea",
      "rows": "28"
    },
    model: {
      value: (_vm.outdata),
      callback: function($$v) {
        _vm.outdata = $$v
      },
      expression: "outdata"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewDetailsVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb37d650"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/dossier.vue
// module id = 655
// module chunks = 1